module.exports = __webpack_public_path__ + "img/uk-cervical-cancer-female.b4c49264.png";